import { DATE_FILTER_CONDITIONS, DATE_WITH_IN } from "../../constants/constants";

export const applySearchCriteria = ({
    searchCriteria,
    repositoryIds,
    contextureMetadata,
    onSearchChange,
    onRepoFilterChange,
    setFiltersConditions,
    sorts = [],
    onSortChange,
}) => {
    const repoId = repositoryIds?.[0];

    const getFieldValidValue = (fieldName, value) => {
        return contextureMetadata?.repos?.[repoId]?.fields
            ?.find(item => item.fieldName === fieldName)
            ?.validValues?.find(v => v.value === value);
    };

    searchCriteria?.children?.forEach(child => {
        const { fieldName, type } = child;

        // MATCH
        if (type === 'match' && fieldName === 'text') {
            onSearchChange?.(child.value);
        }

        // TERMS
        if (type === 'terms' && child.values?.length) {
            const result = getFieldValidValue(fieldName, child.values[0]);
            onRepoFilterChange?.(fieldName, result);
        }

        // RANGE
        if (type === 'range') {
            if (child.gte && child.lte) {
                onRepoFilterChange?.(`${fieldName}Start`, child.gte);
                onRepoFilterChange?.(`${fieldName}End`, child.lte);

                setFiltersConditions?.(prev => ({
                    ...prev,
                    [fieldName]: DATE_FILTER_CONDITIONS[0],
                }));
            } else if (child.gte) {
                onRepoFilterChange?.(fieldName, child.gte);

                setFiltersConditions?.(prev => ({
                    ...prev,
                    [fieldName]: DATE_FILTER_CONDITIONS[1],
                }));
            } else if (child.lte) {
                onRepoFilterChange?.(fieldName, child.lte);

                setFiltersConditions?.(prev => ({
                    ...prev,
                    [fieldName]: DATE_FILTER_CONDITIONS[2],
                }));
            }
        }

        // RELATIVE DATE RANGE
        if (type === 'relDateRange') {
            const { gtTimeUnit, gteDuration } = child;
            
            // Set the condition to 'withIn'
            setFiltersConditions?.(prev => ({
                ...prev,
                [fieldName]: DATE_FILTER_CONDITIONS[3], // 'withIn' option
                [`${fieldName}RelDate`]: DATE_WITH_IN.find(item => item.value === gtTimeUnit) || DATE_WITH_IN[0],
            }));
            
            // Set the duration value
            onRepoFilterChange?.(`${fieldName}RelDateVal`, -gteDuration.toString());
        }
    });

    // Handle sorting
    if (sorts) {
        if (Array.isArray(sorts)) {
            // Multiple sort fields
            const sortFields = sorts.map(sort => ({
                field: sort.fieldName,
                direction: sort.direction
            }));
            onSortChange?.(sortFields, 'multiple');
        } else {
            // Single sort field
            onSortChange?.(searchCriteria.sort.fieldName, searchCriteria.sort.direction);
        }
    }
};